'use strict';

const $ = window.jQuery;

export default class WhiteBooks {
    constructor() {
        $('.white-books__slider').slick({
            fade: true,
            prevArrow: $('.wb-prev'),
            nextArrow: $('.wb-next')
        });
    }
}
